var map = {
	"./2003_cloud_cover.zip": 3184,
	"./2004_cloud_cover.zip": 2935,
	"./2005_cloud_cover.zip": 6038,
	"./2006_cloud_cover.zip": 8749,
	"./2007_cloud_cover.zip": 4596,
	"./2008_cloud_cover.zip": 2603,
	"./2009_cloud_cover.zip": 2010,
	"./2010_cloud_cover.zip": 2820,
	"./2011_cloud_cover.zip": 8973,
	"./2012_cloud_cover.zip": 8310,
	"./2013_cloud_cover.zip": 8231,
	"./2014_cloud_cover.zip": 5328,
	"./2015_cloud_cover.zip": 3529,
	"./2016_cloud_cover.zip": 8402,
	"./2017_cloud_cover.zip": 5475,
	"./2018_cloud_cover.zip": 6268,
	"./2019_cloud_cover.zip": 3125,
	"./2020_cloud_cover.zip": 4357,
	"./2021_cloud_cover.zip": 4780,
	"./2023_cloud_cover.zip": 2862
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7267;
module.exports = webpackAsyncContext;